import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';

import useStyles from './styles';

const CollectorComments = ({ comments }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const visibleComments = comments?.filter((c) => !c.is_hidden) || [];

  const formatDateTime = (iso) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      const hh = d.getHours().toString().padStart(2, '0');
      const mm = d.getMinutes().toString().padStart(2, '0');
      const dd = d.getDate().toString().padStart(2, '0');
      const mon = (d.getMonth() + 1).toString().padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${hh}:${mm} ${dd}/${mon}/${yyyy}`;
    } catch (e) {
      return '';
    }
  };

  if (!visibleComments.length) {
    return null;
  }

  return (
    <Box className={classes.container}>
      <Text className={classes.heading}>{t('collectors_comment')}</Text>

      {visibleComments.map((comment) => (
        <Box
          key={comment.id}
          className={classes.commentItem}
        >
          <Box className={classes.commentHeader}>
            <Box className={classes.commentMeta}>
              <Text className={classes.collectorName}>{t('collector')}</Text>
              <Text className={classes.commentDate}>{formatDateTime(comment.created_at)}</Text>
            </Box>
          </Box>
          <Text
            className={classes.commentContent}
            style={{ whiteSpace: 'pre-wrap' }}
          >
            {comment.content}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default CollectorComments;
